import React from "react";
import { MenuItem, Select, FormControl, InputLabel, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";

const SelectWrappers = ({
  control,
  name,
  label,
  defaultValue,
  data = [],
  width,
  multiple = false,
  disabled,
  validation,
  placeholder,
  height,
  onBlur,
}) => {
  return (
    <FormControl sx={{ width: width || "18.25vw", height }} size="small" disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || (multiple ? [] : "")}
        rules={validation}
        render={({ field, fieldState }) => (
          <React.Fragment>  
            <Select
              {...field}
              multiple={multiple}
              onBlur={onBlur}
              displayEmpty
              renderValue={(selected) =>
                multiple
                  ? selected.length
                    ? selected.join(", ")
                    : placeholder || "Select options"
                  : selected || placeholder
              }
            >
              {data.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
          </React.Fragment>
        )}
      />
    </FormControl>
  );
};

export default SelectWrappers;
